export default __webpack_public_path__ + "static/media/K-ROAD.fd7453ee.png";